import cn from 'classnames';
import React, { FC } from 'react';
import { useParams } from 'react-router';

import { BreadcrumbElementType } from '@/shared/config';
import { useMedia } from '@/shared/hooks';

import { Skeleton } from '../Skeleton/Skeleton';

import styles from './Breadcrumbs.module.scss';
import { DesktopBreadcrumbItem } from './DesktopBreadcrumbItem';
import { MobileBreadcrumbItem } from './MobileBreadcrumbItem';

type BreadcrumbsProps = {
  className?: string;
  testID?: string;
  breadCrumbs: Record<string, BreadcrumbElementType>;
  isClickable?: boolean;
  isPrintPage?: boolean;
};

export const Breadcrumbs: FC<BreadcrumbsProps> = (props) => {
  const {
    className,
    testID,
    breadCrumbs,
    isClickable = true,
    isPrintPage = false,
  } = props;

  const { isMobile } = useMedia();

  const { patientID } = useParams();

  const config = Object.values(breadCrumbs);

  const hasEmptyLabels = config.every((item) => !item.label);

  if (hasEmptyLabels && patientID) {
    return <Skeleton.Filter filtersQuantity={config.length} />;
  }

  const validBreadcrumbs = config.filter((breadcrumb) => breadcrumb.label);

  return (
    <nav className={cn(styles.container, className)} data-testid={testID}>
      {validBreadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.label.toString()}>
          {isMobile ? (
            <MobileBreadcrumbItem
              breadcrumb={breadcrumb}
              isClickable={isClickable || (index === 1 && isPrintPage)}
              isLast={index === validBreadcrumbs.length - 1}
            />
          ) : (
            <DesktopBreadcrumbItem
              breadcrumb={breadcrumb}
              index={index}
              isClickable={isClickable || (index === 1 && isPrintPage)}
              isLast={index === validBreadcrumbs.length - 1}
            />
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
